import { API_LOGIN, API_LOGIN_AZURE } from '../constants/api';
import request from './api';

export const login = data =>
  request(`${API_LOGIN}`, {
    method: 'POST',
    data
  });

export const loginAzure = data =>
  request(`${API_LOGIN_AZURE}`, {
    method: 'POST',
    data
  });
